import {useState} from 'react';
import { AppBar, Toolbar, Typography, Box, Button, IconButton, Drawer, List, ListItem, ListItemText, Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
	const [mobileOpen, setMobileOpen] = useState(false);
	const navigate = useNavigate();

	return (
		<AppBar
		sx={{
			position: 'fixed',
			backgroundColor: 'rgba(24, 24, 24, 1)',
			boxShadow: 'none',
		}}
		>
			<Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
				<Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer'}} onClick={() => navigate('/')}>
					<Avatar src="/jsa_icon.png" alt="Logo" sx={{ width: 52, height: 52, paddingRight: 1 }}/>
					<Typography variant="h6" component="div">
						JSA @ NCSU
					</Typography>
				</Box>

				<Box sx={{ display: { md: 'flex', xs: 'none' } }}>
					{[
						{ text: 'Home', to: '/' },
						{ text: 'Get Involved', to: '/get-involved' },
						{ text: 'Executive Board', to: '/executive-board' },
						{ text: 'Gallery', to: '/gallery' },
					].map((item) => (
						<Button color="inherit" component={RouterLink} to={item.to}>{item.text}</Button>
					))}
				</Box>

				<IconButton
					color="inherit"
					onClick={() => setMobileOpen(true)}
					sx={{ display: { xs: 'flex', md: 'none' } }}
				>
					<MenuIcon />
				</IconButton>

				<Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)} sx={{'& .MuiDrawer-paper': {backgroundColor: 'rgba(24, 24, 24, 1)'}}}>
					 <List sx={{ width: 200 }}>
						{[
							{ text: 'Home', to: '/' },
							{ text: 'Get Involved', to: '/get-involved' },
							{ text: 'Executive Board', to: '/executive-board' },
							{ text: 'Gallery', to: '/gallery' },
						].map((item) => (
							<ListItem
								button
								key={item.text}
								component={RouterLink}
								to={item.to}
								onClick={() => setMobileOpen(false)}
								sx={{
									'&:hover': {
										backgroundColor: 'rgba(255, 255, 255, 0.1)',
									},
									color: 'white'
								}}
							>
								<ListItemText primary={item.text} />
							</ListItem>
						))}
					</List>
				</Drawer>
			</Toolbar>
		</AppBar>
	);
};

export default Navbar;
